// ink-component
import React, { ReactNode, useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';

const DropdownBeltWrapper = styled.label`
  align-items: baseline;
  cursor: pointer;
  display: grid;
  gap: 8px;
  grid-template-columns: ${({ theme }) => theme.columns && `repeat(${theme.columns}, min-content)`};
  width: 100%;
  white-space: ${({ theme }) => (theme.wrap ? 'normal' : 'nowrap')};
  justify-content: ${({ theme }) => (theme.justify === 'center' ? 'center' : 'space-between')};
`;

export interface DropdownBeltProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  /** Belt's children */
  children?: ReactNode;
  /** How should the elements spread */
  justify?: 'spread' | 'center';
  /** Whether the content should be wrapped or not */
  wrap?: boolean;
}

/**
 * @purpose A belt to help organize Dropdown.Item(s) content visually
 * @categories navigation
 * @group Dropdown
 */
const DropdownBelt = (props: DropdownBeltProps) => {
  const { wrap, justify, className, style, ...otherProps } = props;
  const columns = React.Children.count(props.children);
  const themeContext = useContext(ThemeContext);

  return (
    <DropdownBeltWrapper
      className={className}
      tabIndex={-1}
      theme={{ ...themeContext, wrap, justify, columns }}
      {...otherProps}
    >
      {props.children}
    </DropdownBeltWrapper>
  );
};

DropdownBelt.defaultProps = {
  children: undefined,
  justify: 'spread',
  wrap: false,
};

DropdownBelt.displayName = 'Dropdown.Belt';

export default DropdownBelt;
